import { useContext, useReducer } from "react";
import "../../../app/App.scss";
import Header from "../elements/Header";
import translate from "@/i18n/translate";
import { AppContext, AppContextInterface } from "@/contexts/AppContext";
import PssSideNav from "./PssSideNav";
import OrgProfileContent from "./OrgProfileContent";
import ApiError from "../elements/ApiError";
import PreviewModal from "@/features/lightcast/PreviewModal";
import UnauthorizedComponent from "@/features/insights/UnauthorizedComponent";
import { usePageTitle } from "@/hooks/usePageTitle";
import { useIntl } from "react-intl";
import { WmButton, WmModal, WmModalHeader, WmModalFooter } from "@watermarkinsights/ripple-react";

import { defaultOrganization } from "@/features/common/interfaces/Interface";

export interface BodyProps {
  setSelectedTabView: (tabId: string) => void;
  auth: boolean;
  productView?: "planning" | "navigator";
}

type ModalAction = { type: "open" } | { type: "close" };

function modalReducer(_state: boolean, action: ModalAction): boolean {
  return action.type === "open";
}

export default function Body({
  setSelectedTabView,
  auth,
  productView
}: BodyProps): JSX.Element {
  const { institution, isAiAssistantAvailable } = useContext<AppContextInterface>(AppContext);
  const intl = useIntl();
  const pageTitle = institution?.name;
  usePageTitle(pageTitle);
  const [insightsInfoModalOpen, dispatch] = useReducer(modalReducer, false);

  let orgContent;
  if (institution && institution.platformUuid != "") {
    orgContent = (
      <OrgProfileContent
        setSelectedTabView={setSelectedTabView}
        productView={productView}
      />
    );
  } else {
    orgContent = <ApiError containerClasses="api-error margin-top-api-error" />;
  }

  let displayName = institution && institution.name;

  return (
    <>
      {auth ? (
        <>
          <main id="maincontent" className="main-body-container">
            <Header displayName={displayName} productView={productView} />
            <div className="insights-hub-body flex-row">
              <PssSideNav
                organization={null}
                pssOrganization={defaultOrganization}
              />

              <div id="main-org-profile-container" className="main-org-profile">
                <div>
                  <div className="page-banner -insights-header">
                    <div className="titles">{translate("app.header.title")}</div>
                    <div className="description">
                      {translate("app.header.description")}
                    </div>
                    {isAiAssistantAvailable && (
                      <WmButton
                        className="insights-info-button"
                        buttonType="textonly"
                        icon="/images/icons-sprite.svg#info-outline"
                        iconSize="1rem"
                        onClick={() => dispatch({ type: "open" })}
                      >
                        {intl.formatMessage({ id: "app.header.insightsInfoModal.heading" })}
                      </WmButton>
                    )}
                  </div>
                  {isAiAssistantAvailable && (
                    <WmModal
                      open={insightsInfoModalOpen}
                      id="insights-info-modal"
                      uid="insights-info-modal"
                      modalType="dialog"
                      elementToFocus="primary"
                      aria-label="Where do these insights come from?"
                      onWmModalCloseTriggered={() => dispatch({ type: "close" })}
                      onWmModalPrimaryTriggered={() => dispatch({ type: "close" })}
                    >
                      <WmModalHeader heading="Where do these insights come from?"></WmModalHeader>
                      <div className="modal-content body">
                        <p>
                          {translate("app.header.insightsInfoModal.body1")}
                        </p>
                        <p>
                          {translate("app.header.insightsInfoModal.body2")}
                        </p>
                      </div>
                      <WmModalFooter primaryText="Close" deleteStyle={false}></WmModalFooter>
                    </WmModal>
                  )}
                  <div className="body -height" id="tab-components">
                    {orgContent}
                  </div>
                </div>
              </div>
            </div>
          </main>

          <PreviewModal></PreviewModal>
        </>
      ) : (
        <UnauthorizedComponent />
      )}
    </>
  );
}
